import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#424242",
  "fill-rule": "evenodd",
  d: "M3.176 15.434H4.97v-1.598a.52.52 0 0 1 .153-.38.52.52 0 0 1 .38-.153q.227 0 .38.153a.52.52 0 0 1 .153.38v1.598h2.418v-1.598q0-.225.153-.38a.52.52 0 0 1 .38-.153q.225 0 .379.153a.52.52 0 0 1 .153.38v1.598h2.418v-1.598a.52.52 0 0 1 .153-.38.52.52 0 0 1 .38-.153q.227 0 .38.153a.52.52 0 0 1 .153.38v1.598h1.795a.22.22 0 0 0 .177-.085.19.19 0 0 0 .034-.188l-.792-2.923H3.756l-.792 2.923a.19.19 0 0 0 .034.188.22.22 0 0 0 .178.085M14.853 16.5H3.121q-.604 0-.982-.482a1.16 1.16 0 0 1-.214-1.076l.983-3.654V9.71q0-.517.363-.88c.363-.363.535-.363.88-.363h2.951V3.385q0-.785.55-1.335t1.335-.55q.787 0 1.336.55.55.55.55 1.335v5.082h2.95q.519 0 .88.363.364.363.364.88v1.578l.983 3.668q.197.586-.187 1.065a1.23 1.23 0 0 1-1.01.479"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }